var f = Object.defineProperty;
var n = (t, r) => f(t, "name", { value: r, configurable: !0 });

// src/test/preview.ts
import { definePreviewAddon as a } from "storybook/internal/csf";
import { instrument as m } from "storybook/internal/instrumenter";
import {
  clearAllMocks as p,
  fn as l,
  isMockFunction as d,
  resetAllMocks as b,
  restoreAllMocks as u,
  uninstrumentedUserEvent as g,
  within as k
} from "storybook/test";
var y = /* @__PURE__ */ n(({ parameters: t }) => {
  t?.test?.mockReset === !0 ? b() : t?.test?.clearMocks === !0 ? p() : t?.test?.restoreMocks !== !1 && u();
}, "resetAllMocksLoader"), s = /* @__PURE__ */ n((t, r = 0, o) => {
  if (r > 5 || t == null)
    return t;
  if (d(t))
    return o && t.mockName(o), t;
  if (typeof t == "function" && "isAction" in t && t.isAction && !("implicit" in t && t.implicit)) {
    let e = l(t);
    return o && e.mockName(o), e;
  }
  if (Array.isArray(t)) {
    r++;
    for (let e = 0; e < t.length; e++)
      Object.getOwnPropertyDescriptor(t, e)?.writable && (t[e] = s(t[e], r));
    return t;
  }
  if (typeof t == "object" && t.constructor === Object) {
    r++;
    for (let [e, c] of Object.entries(t))
      Object.getOwnPropertyDescriptor(t, e)?.writable && (t[e] = s(c, r, e));
    return t;
  }
  return t;
}, "traverseArgs"), T = /* @__PURE__ */ n(({ initialArgs: t }) => {
  s(t);
}, "nameSpiesAndWrapActionsInSpies"), i = !1, w = /* @__PURE__ */ n(async (t) => {
  if (globalThis.HTMLElement && t.canvasElement instanceof globalThis.HTMLElement && (t.canvas = k(t.canvasElement)), globalThis.window?.navigator?.
  clipboard) {
    t.userEvent = m(
      { userEvent: g.setup() },
      { intercept: !0 }
    ).userEvent;
    let r = HTMLElement.prototype.focus;
    i || Object.defineProperties(HTMLElement.prototype, {
      focus: {
        configurable: !0,
        set: /* @__PURE__ */ n((o) => {
          r = o, i = !0;
        }, "set"),
        get: /* @__PURE__ */ n(() => r, "get")
      }
    });
  }
}, "enhanceContext"), F = /* @__PURE__ */ n(() => a({
  loaders: [y, T, w]
}), "default");
export {
  F as default,
  s as traverseArgs
};
